import React, { useContext } from 'react';
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Button, Col, Row } from "react-bootstrap";
import { AuthContext } from '../context/AuthContext';
import { showSweetAlert } from './SweetAlert';

function PreviewOrderPopup ({ open, onClose, orderParams, thirdParyAccount, symbol_type, setConfirmationMessage, setConfirmationId, setConfirmationRequired, setVerified, setAmount }) {

    const {userData, baseCurencySymbol, curencySymbol, symbolData, createOrder, getOrderData} = useContext(AuthContext);

    if (!orderParams) return null; // Prevent rendering if orderParams is null
    console.log(orderParams);
    const { quantity, side, cashqty, ordertype, qtyType, callput, strikePrice, timeInForce } = orderParams;
    
    const handleSubmit = async () => {
        let orderParams;
        if(thirdParyAccount === 'IBKR'){
            orderParams = {
                quantity: quantity,
                side: side,
                cashqty: cashqty,
                ordertype: ordertype
            };
        }
        else if(thirdParyAccount === 'etrade'){
            if(symbol_type === 'otc'){
                orderParams = {
                    quantity: quantity,
                    side: side,
                    qtyType: qtyType,
                    ordertype: ordertype
                };
            }else if(symbol_type === 'stocks' || symbol_type === 'indices'){
                orderParams = {
                    quantity: quantity,
                    side: side,
                    qtyType: qtyType,
                    ordertype: ordertype,
                    timeInForce: timeInForce
                };
            }
        }
        else if(thirdParyAccount === 'cryptocom' || thirdParyAccount === 'coinbase'){
            // Crypto.com and Coinbase use similar structure
            orderParams = {
                quantity: quantity,
                side: side,
                ordertype: ordertype,
                cashqty: cashqty,
                qtyType: qtyType,
                timeInForce: timeInForce  // Include timeInForce for LIMIT orders
            };
        }
        else {
            // Default structure for other providers
            orderParams = {
                quantity: quantity,
                side: side,
                cashqty: cashqty,
                ordertype: ordertype,
                qtyType: qtyType
            };
        }
        
        // Validate orderParams exists and has required fields
        if (!orderParams || !orderParams.quantity) {
            showSweetAlert('Error!', 'Invalid order parameters. Please check your order details.', 'error');
            return;
        }
        
        try {
            const response = await createOrder(
                orderParams.quantity, 
                orderParams.side, 
                orderParams.ordertype, 
                orderParams.cashqty, 
                thirdParyAccount, 
                symbolData, 
                baseCurencySymbol, 
                curencySymbol,
                symbol_type,
                orderParams.qtyType,
                callput,
                strikePrice,
                orderParams.timeInForce
            );
        
            // Validate response exists
            if (!response) {
                showSweetAlert('Error!', 'No response received from server', 'error');
                onClose(false);
                return;
            }
        
            let success = false;
        
            if (response.details &&
                Array.isArray(response.details) &&
                response.details.length > 0) {
                // If details exist, check the order status
                // const orderStatus = response.details[0]?.order_status;
                // if (orderStatus === 'PreSubmitted' || orderStatus === 'Submitted') {
                //     // setVerified(false);
                //     // setAmount('');
                //     getOrderData(thirdParyAccount, userData?.integrations?.trade_account_id);
                //     success = true;
                // } else {
                //     // If details exist but order status is unexpected
                //     showSweetAlert('Error!', `Unexpected order status: ${orderStatus}`, 'error');
                // }
                const detail = response.details[0];

                if (detail.message && detail.id) {
                    setConfirmationMessage(detail.message[0]);
                    setConfirmationId(detail.id);
                    setConfirmationRequired(true);
                    return;
                }

                // Handle success directly
                if ('order_id' in detail) {
                    setVerified(false);
                    setAmount('');
                    getOrderData(thirdParyAccount, userData?.integrations?.trade_account_id);
                }
            } else if (response?.success === true) {
                // If details do not exist but success is true
                // setVerified(false);
                // setAmount('');
                getOrderData(thirdParyAccount, userData?.integrations?.trade_account_id);
                success = true;
            } else if (response?.success === false) {
                // If success is explicitly false
                showSweetAlert('Error!', response?.error_response?.message || response?.error_response?.error_details || 'An error occurred', 'error');
            }else if(response?.PlaceOrderResponse){
                // setVerified(false);
                // setAmount('');
                getOrderData(thirdParyAccount, userData?.integrations?.trade_account_id);
                success = true;
            }else if(response?.error){
                // Handle error response - could be from Crypto.com or other providers
                let errorMessage = 'An error occurred';
                
                // Check if error is a string (Crypto.com format: { error: "message", code: ... })
                if (typeof response.error === 'string') {
                    errorMessage = response.error;
                } else if (response.details) {
                    // Try to parse details if it exists (for other providers like E*Trade)
                    try {
                        const details = JSON.parse(response.details || '{}');
                        errorMessage = details?.Error?.message || errorMessage;
                    } catch (e) {
                        // If parsing fails, use error as-is
                        errorMessage = response.error || errorMessage;
                    }
                }
                
                showSweetAlert('Error!', errorMessage, 'error');
                onClose(false);
                return;
            }
            else if(thirdParyAccount !== 'etrade') {
                console.log(thirdParyAccount);
                // Catch any other unknown failure cases
                showSweetAlert('Error!', response?.error_details || "Something went wrong!", 'error');
            }

            onClose(success);
            
        } catch (error) {
            // Extract error message from API response if available
            let errorMessage = "Unexpected error occurred";
            
            if (error.response?.data) {
                const errorData = error.response.data;
                
                // Map Crypto.com error codes to user-friendly messages
                const errorCodeMessages = {
                    306: "Insufficient funds or assets available for this order. Please check your account balance.",
                    10001: "Invalid request parameters.",
                    10002: "Invalid API key or secret.",
                    10003: "Invalid signature.",
                    10004: "Rate limit exceeded. Please try again later.",
                    10005: "Permission denied. Please check your API key permissions.",
                    10006: "Internal server error. Please try again later.",
                };
                
                // For Crypto.com, prioritize message field and map error codes
                if (errorData.code && errorCodeMessages[errorData.code]) {
                    errorMessage = errorCodeMessages[errorData.code];
                } else if (errorData.message && errorData.message !== errorData.error) {
                    // If message is different from error, use it
                    if (errorData.message.includes('_')) {
                        // Convert "INSUFFICIENT_AVAILABLE_BALANCE" to "Insufficient available balance"
                        errorMessage = errorData.message
                            .split('_')
                            .map(word => word.charAt(0) + word.slice(1).toLowerCase())
                            .join(' ');
                    } else {
                        errorMessage = errorData.message;
                    }
                } else if (errorData.error) {
                    errorMessage = errorData.error;
                } else if (errorData.error_details) {
                    errorMessage = errorData.error_details;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            showSweetAlert('Error!', errorMessage, 'error');
            onClose(false);
        }
    };

    return(
        <Dialog open={open} onClose={() => onClose(false)} aria-labelledby="settings-dialog-title" fullWidth PaperProps={{
            style: {
                width: '480px',
                maxWidth: '100%',
            },
        }} className="setting-dialog">
            <DialogTitle id="settings-dialog-title" className="d-flex justify-content-between mb-2">
                Order Preview
                <img style={{ float: 'none', height: "22px", width: "20px" }} src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" className="close-icon" role="button" onClick={() => onClose(false)} />
            </DialogTitle>
            <DialogContent>
                <Row className="p-0 align-items-center mb-3">
                    <Col className="flex-grow-1">
                        <h6>Market</h6>
                    </Col>
                    <Col sm="auto" className="text-end">
                        <p className="gray-text-only mb-0">{symbolData}</p>
                    </Col>
                </Row>
                <Row className="p-0 align-items-center mb-3">
                    <Col className="flex-grow-1">
                        <h6>Amount</h6>
                    </Col>
                    <Col sm="auto" className="text-end">
                        <p className="gray-text-only mb-0">{quantity}</p>
                    </Col>
                </Row>
                <Row className="p-0 align-items-center mb-3">
                    <Col className="flex-grow-1">
                        <h6>Type</h6>
                    </Col>
                    <Col sm="auto" className="text-end" >
                        <p className="gray-text-only mb-0" style={{cursor:'pointer'}}>{ordertype}</p>
                    </Col>
                </Row>
                {symbol_type === 'otc' &&
                    <>
                        <Row className="p-0 align-items-center mb-3">
                            <Col className="flex-grow-1">
                                <h6>CALL/PUT</h6>
                            </Col>
                            <Col sm="auto" className="text-end" >
                                <p className="gray-text-only mb-0" style={{cursor:'pointer'}}>{callput}</p>
                            </Col>
                        </Row>
                        <Row className="p-0 align-items-center mb-3">
                            <Col className="flex-grow-1">
                                <h6>Strike Price</h6>
                            </Col>
                            <Col sm="auto" className="text-end" >
                                <p className="gray-text-only mb-0" style={{cursor:'pointer'}}>{strikePrice}</p>
                            </Col>
                        </Row>
                    </> 
                }
                
                <div className="mb-3 row justify-content-center">
                    <Button variant="primary" style={{backgroundColor: '#317CFF', textTransform: 'none'}} 
                        className="mt-1 w-55 p-2 theme-btn-email" onClick={handleSubmit}
                    >
                    Place {side} order
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default PreviewOrderPopup;